module.exports = __webpack_public_path__ + "img/rlcbg_img.3ecfc344.png";